








































import Vue from "vue";

const MESSAGES = [
    "Please leave the gem alone.",
    "Look, mitts off the gem, okay?",
    "Hey! We don't want your grubby fingerprints all over our gem! Bugger off!",

    /*
    OLD TEXT:
    "Stop poking at the gem! What the hell's wrong with you?",
    "I'm warning you, I'll call the cops!",
    "That's it. One more time and you're finished!",
    "This is the last warning you're getting. No more mister nice cartoonists!",
    "I'm calling them now.. No, it's too late to beg for mercy.",
    "Man, you just don't know when to quit do you? .. Ah, officer! Yes, it's like this .. NO, DON'T PUT ME ON HOLD!",
    "Well, no, they haven't actually STOLEN it.. but they keep poking it! That's got to be illegal, right?",
    "Well, apparently poking at people's gems is not a crime. Honestly, what is the world coming to.",
    "Please go bother some other cartoonist, ok?"
    */
    
    "Wait a minute... you look familiar. Weren't you here 20 years ago too, poking at our gem?",
    "Okay, so here we are, two decades later. I would've hoped you'd matured a bit by now.",
    "But apparently fondling other people's precious minerals is still a hobby of yours.",
    "Oh, it belongs in a museum? You probably think you're pretty clever. Think you're the first one to come up with that joke.",
    "I'll have you know that this 'gem' is actually a top-secret sci-fi research project.",
    "That's right, it's the first step towards a transporter as seen in Star Trek.",
    "Don't believe me? Fine. Go ahead, touch the gem one more time. I dare you.",
    "I warned you! Here you go! Better hope your pattern buffers aren't scrambled by chronoton interference!"
];

const RANDOM_SITES = [
    // Old sites
    'http://www.oocities.org/#gsc.tab=0',
    'https://web.archive.org/web/19990208010918/http://www.wi.leidenuniv.nl/',

    // Misc pop culture / cult classics
    'https://festivusweb.com/index.php',
    'https://tvtropes.org/pmwiki/pmwiki.php/Main/CrazyEnoughToWork',
    'https://tvtropes.org/pmwiki/pmwiki.php/Trivia/Firefly',
    'https://www.imdb.com/title/tt0105643/',

    // Memes
    'https://www.spaghettimonster.org/',
    'http://talklikeapirate.com/wordpress/sample-page/',
    'http://www.hamsterdance.org/hamsterdance/',
    'https://theuselessweb.com/',

    // Games
    'https://en.wikipedia.org/wiki/Super_Monkey_Ball_(video_game)',
    'http://www.chaseace.com/',
    'https://gameplayheaven.com/hacker.html',

];

export default Vue.extend({
    props: {
        fixed: Boolean
    },

    data() {
        return {
            expanded: false,
            count: 0,
        };
    },

    mounted() {
        document.body.addEventListener('click', this.closeMenu);
    },

    beforeDestroy() {
        document.body.removeEventListener('click', this.closeMenu);
    },

    methods: {
        toggleMenu(e: Event) {
            this.expanded = !this.expanded;
        },
        
        closeMenu(e: MouseEvent) {
            if (this.expanded) {
                this.expanded = false;
                e.preventDefault();
            }
        },

        clickName(e: KeyboardEvent) {
            if (!window.localStorage.gemClicked || e.ctrlKey) {
                window.localStorage.gemClicked = 0;
            }
            if (window.localStorage.gemClicked < MESSAGES.length) {
                // Show a sequence of messages
                const msg = MESSAGES[window.localStorage.gemClicked];
                alert(msg);
                window.localStorage.gemClicked++;
            }
            if (window.localStorage.gemClicked >= MESSAGES.length) {
                // Redirect to a random site
                const i = Math.floor(Math.random() * RANDOM_SITES.length);
                const url = RANDOM_SITES[i];
                window.open(url, '_blank');
            }
        },
    },
});
